import { Box, Typography } from '@mui/material';
import TeamEndScore from './teamEndScore';
import { GameStatus } from '../../../constants/gameConstants';
import TeamFinalScore from './teamFinalScore';
import TeamSetFinalScore from './teamSetFinalScore';

const ScoreDisplay = ({ game }) => {
  const currentSet = game?.sets?.find((set) => set.id === game.currentSet);
  const getElementByGameStatus = (team) => {
    switch (game.status) {
      case GameStatus.COMPLETE:
        return <TeamFinalScore team={team} game={game} />;
      case GameStatus.IN_PROGRESS:
        return currentSet && currentSet.isDone && currentSet.winningId ? (
          <TeamSetFinalScore team={team} game={game} />
        ) : (
          <TeamEndScore team={team} game={game} />
        );
      case GameStatus.PLAYOFF:
        return <TeamEndScore team={team} game={game} />;
      default:
        return <TeamEndScore team={team} game={game} />;
    }
  };

  return game && game.teams?.teamA && game.teams?.teamB ? (
    <Box
      display="grid"
      gridTemplateColumns={'minmax(0, 1fr) auto minmax(0, 1fr)'}
      justifyItems={'center'}
      alignItems={'center'}
      columnGap={1}
      width="100%">
      <Box display="flex" justifyContent="center" width="100%" minWidth={0}>
        {getElementByGameStatus(game.teams.teamA)}
      </Box>
      <Typography>VS</Typography>
      <Box display="flex" justifyContent="center" width="100%" minWidth={0}>
        {getElementByGameStatus(game.teams.teamB)}
      </Box>
    </Box>
  ) : null;
};

export default ScoreDisplay;
